export default "__VITE_ASSET__165de13d__"